<template>
    <footer class="layout-footer">
        <div class="layout-footer-inner">
            <ul class="footer">
                <li>© 2014-2021  北京修齐治平科技有限公司</li>
                <li>
                    <a target="_blank" href="https://beian.miit.gov.cn/"><span>京ICP备16000182号-5</span></a>
                    <span>|</span>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042360">
                        <img src="../../../../assets/images/common/gaba.png" class="footer-gaba">
                        <span>京公网安备11010502042360号</span>
                    </a>
                </li>
            </ul>
        </div>
    </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
a:hover {
    color: #8898af;
    text-decoration: none;
}
a:link {
    color: #8898af;
    text-decoration: none;
}
a:active {
    color: #8898af;
    text-decoration: none;
}
a:visited {
    color: #8898af;
    text-decoration: none;
}
.footer {
    font-size: 12px;
    text-align: center;
    color: #8898af;
    
    .footer-gaba {
        margin-bottom: -4px;
    }

    li {
        margin-bottom: 10px;

        span {
            margin-left: 3px;
            margin-right: 3px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/common/AppFooter.vue